<div class="field-panel">
  <div class="panel-title lato-18-b-vw txt-clr">
    {{ isEditMode ? 'Edit Dynamic Field' : 'New Dynamic Field' }}
  </div>
  <div class="panel-divider"></div>

  <!-- Field Title -->
  <div class="panel-row">
    <div class="row-label lato-16-n-vw">
      Field Title<span class="row-required" aria-hidden="true">*</span>
    </div>
    <div class="row-control">
      <input class="control-plate lato-16-n-vw" type="text" name="dynamicFieldTitle"
        aria-label="Field title" placeholder="e.g. Coverage Amount" [(ngModel)]="label" />
    </div>
  </div>

  <!-- Type -->
  <div class="panel-row panel-row--top">
    <div class="row-label lato-16-n-vw">
      Type<span class="row-required" aria-hidden="true">*</span>
    </div>
    <div class="row-control field-picker">
      <div class="control-plate control-plate--select lato-16-n-vw" role="button" tabindex="0"
        aria-label="Select field type" [attr.aria-expanded]="isTypeOpen" (click)="toggleTypeList()"
        (keydown.enter)="toggleTypeList(); $event.preventDefault()"
        (keydown.space)="toggleTypeList(); $event.preventDefault()">
        <span [ngClass]="type ? 'plate-value' : 'plate-placeholder'">
          {{ type ? selectedTypeLabel : 'Select type' }}
        </span>
        <span class="plate-chevron" [ngClass]="{ 'plate-chevron--open': isTypeOpen }" cygovSvgIcon
          [svgName]="'arrow-right-type1'"></span>
      </div>

      <div class="picker-list" role="listbox" aria-label="Field type" *ngIf="isTypeOpen">
        <div class="picker-option lato-16-n-vw" *ngFor="let option of typeOptions;
          trackBy: trackByOptionId" role="option" tabindex="0"
          [attr.aria-selected]="option.id === type"
          [ngClass]="{ 'picker-option--selected': option.id === type }" (click)="selectType(option)"
          (keydown.enter)="selectType(option); $event.preventDefault()"
          (keydown.space)="selectType(option); $event.preventDefault()">
          {{ option.name }}
        </div>
      </div>
    </div>
  </div>

  <!-- Currency: the extra row a CURRENCY field owns (spec node 117:10771). -->
  <div class="panel-row panel-row--top" *ngIf="needsCurrency">
    <div class="row-label lato-16-n-vw">
      Currency<span class="row-required" aria-hidden="true">*</span>
    </div>
    <div class="row-control field-picker">
      <div class="control-plate control-plate--select lato-16-n-vw" role="button" tabindex="0"
        aria-label="Select currency" [attr.aria-expanded]="isCurrencyOpen"
        (click)="toggleCurrencyList()"
        (keydown.enter)="toggleCurrencyList(); $event.preventDefault()"
        (keydown.space)="toggleCurrencyList(); $event.preventDefault()">
        <span [ngClass]="currency ? 'plate-value' : 'plate-placeholder'">
          {{ currency ? selectedCurrencyLabel : 'Select currency' }}
        </span>
        <span class="plate-chevron" [ngClass]="{ 'plate-chevron--open': isCurrencyOpen }"
          cygovSvgIcon [svgName]="'arrow-right-type1'"></span>
      </div>

      <div class="picker-list" role="listbox" aria-label="Currency" *ngIf="isCurrencyOpen">
        <div class="picker-option lato-16-n-vw" *ngFor="let option of currencyOptions;
          trackBy: trackByOptionId" role="option" tabindex="0"
          [attr.aria-selected]="option.id === currency"
          [ngClass]="{ 'picker-option--selected': option.id === currency }"
          (click)="selectCurrency(option)"
          (keydown.enter)="selectCurrency(option); $event.preventDefault()"
          (keydown.space)="selectCurrency(option); $event.preventDefault()">
          {{ option.name }}
        </div>
      </div>
    </div>
  </div>

  <div class="panel-row panel-row--top" *ngIf="needsOptions">
    <div class="row-label lato-16-n-vw">
      Options<span class="row-required" aria-hidden="true">*</span>
    </div>
    <div class="row-control">
      <div class="option-box">
        <div class="option-box-header">
          <div class="option-box-title lato-14-n-vw">
            {{ options.length }} {{ options.length === 1 ? 'option' : 'options' }}
          </div>
          <span class="option-add-icon" cygovSvgIcon [svgName]="'add-icon'" role="button"
            tabindex="0" aria-label="Add a dropdown option" (click)="showAddOptionBox()"
            (keydown.enter)="showAddOptionBox(); $event.preventDefault()"
            (keydown.space)="showAddOptionBox(); $event.preventDefault()"></span>
        </div>

        <div class="option-add-box" *ngIf="isAddingOption">
          <input class="option-add-input lato-14-n-vw" type="text" name="newDynamicFieldOption"
            autofocus aria-label="New option name" placeholder="Option name"
            [(ngModel)]="newOptionName" (keydown.enter)="addOption(); $event.preventDefault()" />
          <div class="option-add-close" role="button" tabindex="0" aria-label="Cancel adding option"
            (click)="closeAddOptionBox()"
            (keydown.enter)="closeAddOptionBox(); $event.preventDefault()"
            (keydown.space)="closeAddOptionBox(); $event.preventDefault()">
            <span aria-hidden="true">&times;</span>
          </div>
          <button class="option-add-btn lato-12-n-vw" type="button"
            [disabled]="!newOptionName?.trim()" (click)="addOption()">Add</button>
        </div>

        <div class="option-list">
          <div class="option-tag" *ngFor="let option of options; trackBy: trackByOptionId">
            <span class="option-tag-name lato-14-n-vw">{{ option.name }}</span>
            <span class="option-tag-remove" role="button" tabindex="0"
              [attr.aria-label]="'Remove option ' + option.name" (click)="removeOption(option)"
              (keydown.enter)="removeOption(option); $event.preventDefault()"
              (keydown.space)="removeOption(option); $event.preventDefault()">
              <span aria-hidden="true">&times;</span>
            </span>
          </div>
          <div class="option-empty lato-14-n-vw" *ngIf="!options.length && !isAddingOption">
            No options yet — use + to add the first one.
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mandatory field -->
  <div class="panel-row">
    <div class="row-label lato-16-n-vw">Mandatory field</div>
    <div class="row-control row-control--toggle">
      <cygov-toggle-button [id]="'dynamic-field-mandatory'" [isChecked]="required"
        [useGlobalState]="false" (changed)="required = $event">
      </cygov-toggle-button>
      <span class="row-hint lato-14-n-vw">Shown with a red asterisk everywhere the field
        appears</span>
    </div>
  </div>

  <!-- Usage warning — edit mode only, and only when the field is actually in use. -->
  <div class="panel-row" *ngIf="isEditMode && usageCount">
    <div class="row-label"></div>
    <div class="row-control">
      <span class="row-hint lato-14-n-vw">In use by {{ usageCount }}
        {{ usageCount === 1 ? 'risk' : 'risks' }}. Changing the type may clear values already
        entered.</span>
    </div>
  </div>

  <div class="panel-error lato-14-n-vw" *ngIf="errorMessage" role="alert">{{ errorMessage }}</div>

  <div class="panel-actions" [ngClass]="{ 'panel-actions--edit': isEditMode }">
    <div class="action-spacer" *ngIf="isEditMode"></div>
    <div class="action-buttons">
      <button class="action-btn action-btn--cancel lato-18-n-vw" type="button" [disabled]="isSaving"
        (click)="onCancel()">CANCEL</button>
      <button class="action-btn action-btn--save lato-18-n-vw" type="button" [disabled]="isSaving"
        (click)="onSave()">SAVE</button>
    </div>
    <button class="action-btn action-btn--delete lato-18-n-vw" type="button" *ngIf="isEditMode"
      [disabled]="isSaving" (click)="onDelete()">DELETE FIELD</button>
  </div>
</div>